import { useEffect, useState, useRef } from "react";
import "../stylesheets/main.scss";
import Image from "next/image";
import scrollDown from "../../../public/assets/svg/dwn-arrow.svg";

export default function ScrollMessage() {
  return (
    <div className="instruction">
      <Image
        src={scrollDown}
        alt=""
        role="presentation"
        className="arrows"
        id="ar-1"
      />
      <Image
        src={scrollDown}
        alt=""
        role="presentation"
        className="arrows"
        id="ar-2"
      />
      <Image
        src={scrollDown}
        alt=""
        role="presentation"
        className="arrows"
        id="ar-3"
      />
      <h3 className="scroll-message"> scroll to continue </h3>
    </div>
  );
}
